// extracted by mini-css-extract-plugin
export default {"OrdersMain":"orders_OrdersMain__fxIqa","Orders":"orders_Orders__1z9F7"};